module.exports = __webpack_public_path__ + "img/notfound.c0ae3e93.png";